import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  exportExcel,
  getLastData,
} from '@/api/simflowpoolrecordserv'

export default {
  state: {
    state_SimFlowPoolRecord_GetAllResult: null,
    state_SimFlowPoolRecord_SearchByNameResult: null,
    state_SimFlowPoolRecord_GetPageResult: null,
    state_SimFlowPoolRecord_GetDetailResult: null,
    state_SimFlowPoolRecord_ExportExcelResult: null,
    state_SimFlowPoolRecord_GetLastDataResult: null,
  },
  mutations: {
    SET_SIMFLOWPOOLRECORD_GETALL_RESULT: (state, rst) => {
      state.state_SimFlowPoolRecord_GetAllResult = rst;
    },
    SET_SIMFLOWPOOLRECORD_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_SimFlowPoolRecord_SearchByNameResult = rst;
    },
    SET_SIMFLOWPOOLRECORD_GETPAGE_RESULT: (state, rst) => {
      state.state_SimFlowPoolRecord_GetPageResult = rst;
    },
    SET_SIMFLOWPOOLRECORD_GETDETAIL_RESULT: (state, rst) => {
      state.state_SimFlowPoolRecord_GetDetailResult = rst;
    },
    SET_SIMFLOWPOOLRECORD_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_SimFlowPoolRecord_ExportExcelResult = rst;
    },
    SET_SIMFLOWPOOLRECORD_GETLASTDATA_RESULT: (state, rst) => {
      state.state_SimFlowPoolRecord_GetLastDataResult = rst;
    },
  },
  actions: {
    SimFlowPoolRecordServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMFLOWPOOLRECORD_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMFLOWPOOLRECORD_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimFlowPoolRecordServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMFLOWPOOLRECORD_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMFLOWPOOLRECORD_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimFlowPoolRecordServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMFLOWPOOLRECORD_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMFLOWPOOLRECORD_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimFlowPoolRecordServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMFLOWPOOLRECORD_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMFLOWPOOLRECORD_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimFlowPoolRecordServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMFLOWPOOLRECORD_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMFLOWPOOLRECORD_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimFlowPoolRecordServ_GetLastData({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getLastData(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMFLOWPOOLRECORD_GETLASTDATA_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMFLOWPOOLRECORD_GETLASTDATA_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_SimFlowPoolRecord_GetAllResult: state => {
      return state.state_SimFlowPoolRecord_GetAllResult;
    },
    get_SimFlowPoolRecord_SearchByNameResult: state => {
      return state.state_SimFlowPoolRecord_SearchByNameResult;
    },
    get_SimFlowPoolRecord_GetPageResult: state => {
      return state.state_SimFlowPoolRecord_GetPageResult;
    },
    get_SimFlowPoolRecord_GetDetailResult: state => {
      return state.state_SimFlowPoolRecord_GetDetailResult;
    },
    get_SimFlowPoolRecord_ExportExcelResult: state => {
      return state.state_SimFlowPoolRecord_ExportExcelResult;
    },
    get_SimFlowPoolRecord_GetLastDataResult: state => {
      return state.state_SimFlowPoolRecord_GetLastDataResult;
    },
  }
}